import React, { useState } from "react";
import { Layout, Menu, Button, Typography, message } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, DashboardOutlined, UserOutlined, FileDoneOutlined, TeamOutlined, SettingOutlined} from "@ant-design/icons";
import Dashboard from "./Admincomponents/Dashboard";
import Merchantonboard from "./Admincomponents/Merchantonboard";
import UsersManagement from "./Admincomponents/Users";
import { useAuthContext } from "../Hooks/UseAuthContext";

const { Header, Sider, Content } = Layout;

const { Title } = Typography;

const Admin = () => {

    const { dispatch } = useAuthContext();
    const [collapsed, setCollapsed] = useState(false);

    const [selectedMenu, setSelectedMenu] = useState("dashboard");

    const items = [
        {
            key: "dashboard",
            icon: <DashboardOutlined />,
            label: "Dashboard",
        },
        {
            key: "onboarding",
            icon: <FileDoneOutlined />,
            label: "Merchant Onboarding",
        },

        {
            key: "users",
            icon: <TeamOutlined />,
            label: "Users",
        },
        {
            key: "admins",
            icon: <UserOutlined />,
            label: "Admin Team",
        },
        {
            key: "settings",
            icon: <SettingOutlined />,
            label: "Settings",
        },
    ];

    // =====================================
    // RENDER COMPONENTS
    // =====================================

    const renderComponent = () => {

        switch (selectedMenu) {

            case "dashboard":

                return (
                    <div>
                        <Title level={3}>
                            Dashboard
                        </Title>
                        <>
                            <Dashboard />
                        </>
                    </div>
                );

            case "onboarding":

                return (
                    <div>
                        <Title level={3}>
                            Merchant Onboarding
                        </Title>

                        <>
                            <Merchantonboard />
                        </>
                    </div>
                );

            case "users":

                return (
                    <div>
                        <Title level={3}>
                            Users
                        </Title>

                        <>
                            <UsersManagement />
                        </>
                    </div>
                );

            case "admins":

                return (
                    <div>
                        <Title level={3}>
                            Admin Team
                        </Title>

                        <p>
                            Admin management here
                        </p>
                    </div>
                );

            case "settings":

                return (
                    <div>
                        <Title level={3}>
                            Settings
                        </Title>

                        <p>
                            Settings page here
                        </p>
                    </div>
                );

            default:

                return null;
        }
    };

    const Logout = () => {
        message.loading('Logging out...', 1.5).then(() => {
            message.success('Logged out successfully');
            dispatch({ type: 'LOGOUT' });
            localStorage.removeItem('user');
            localStorage.removeItem('expiryTime');
            //window.location.reload();
            window.location.href = '/admin/login'; // Redirect to admin login page after logout
        })
    }

    return (

        <Layout
            style={{
                minHeight: "100vh",
            }}
        >

            {/* ===================================== */}
            {/* SIDEBAR */}
            {/* ===================================== */}

            <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                width={260}
                style={{

                    position: "fixed",

                    left: 0,

                    top: 0,

                    bottom: 0,

                    overflow: "auto",
                }}
            >

                {/* LOGO */}

                <div
                    style={{

                        height: 64,

                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        color: "#fff",

                        fontSize: 20,

                        fontWeight: 700,

                        borderBottom:
                            "1px solid rgba(255,255,255,0.1)",
                    }}
                >

                    {collapsed
                        ? "BOOM"
                        : "BOOM PAY"}

                </div>

                {/* MENU */}

                <Menu
                    theme="dark"

                    mode="inline"

                    selectedKeys={[selectedMenu]}

                    onClick={(e) =>
                        setSelectedMenu(e.key)
                    }

                    items={items}

                    style={{
                        marginTop: 10,
                    }}
                />

            </Sider>

            {/* ===================================== */}
            {/* RIGHT SIDE */}
            {/* ===================================== */}

            <Layout
                style={{
                    marginLeft:
                        collapsed ? 80 : 260,

                    transition:
                        "all 0.2s",
                }}
            >

                {/* HEADER */}

                <Header
                    style={{

                        padding:
                            "0 20px",

                        background:
                            "#fff",

                        display:
                            "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "space-between",

                        boxShadow:
                            "0 1px 4px rgba(0,0,0,0.1)",

                        position:
                            "sticky",

                        top: 0,

                        //zIndex: 999,
                    }}
                >

                    <Button
                        type="text"

                        icon={
                            collapsed
                                ? <MenuUnfoldOutlined />
                                : <MenuFoldOutlined />
                        }

                        onClick={() =>
                            setCollapsed(!collapsed)
                        }

                        style={{
                            fontSize: 18,
                        }}
                    />

                    <Title
                        level={5}
                        style={{
                            margin: 0,
                            cursor: 'pointer'
                        }}
                        onClick={Logout}
                    >

                        Admin: BOOM PAY TECHNOLOGY PVT LTD

                    </Title>

                </Header>

                {/* CONTENT */}

                <Content
                    style={{

                        margin: 20,

                        padding: 24,

                        minHeight: "calc(100vh - 100px)",

                        background: "#fff",

                        borderRadius: 10,

                        overflow: "auto",
                    }}
                >

                    {renderComponent()}

                </Content>

            </Layout>

        </Layout>
    );
};

export default Admin;